import { useEffect, useState } from 'react';
import { fetchSubjects, Subject } from '../api/methodsApi';
import useThrowAsyncError from '../../../hooks/useThrowAsyncError';

function useSubjects() {
  const handleError = useThrowAsyncError();
  const { REACT_APP_P_STUDIO_GROUP } = process.env;

  const [subjects, setSubjects] = useState<Subject[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    async function fetchData() {
      setLoading(true);

      try {
        const fetched = await fetchSubjects(REACT_APP_P_STUDIO_GROUP);
        setSubjects(fetched);
      } catch (e) {
        handleError(e);
      } finally {
        setLoading(false);
      }
    }

    fetchData();
  }, [REACT_APP_P_STUDIO_GROUP, handleError]);

  return { subjects, loading };
}

export default useSubjects;
